import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";

const Profilesec1 = () => {
  return (
    <div className="home-banner-container ">
      <Swiper
        spaceBetween={0}
        centeredSlides={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        modules={[Autoplay, Pagination]}
        className="mySwiper home-banner-swiper m-0 w-100"
      >
        <SwiperSlide>
          <div
            className="slide-inner-wrapper"
            style={{ backgroundImage: `url('../images/images1.jpeg')` }}
          >
            <div className="px-0 h-100 d-flex align-items-center position-relative z-2 container">
              <div className="row w-100 m-0 ">
                <div className="px-0 h-100 d-flex position-relative z-2">
                  <div className="text-start banner-text-block">
                    <h1 className="main-heading">
                      <span className="heading-part-1">One Donation</span>{" "}
                      <br />
                      <span className="heading-part-2">Is Recycled</span> <br />
                      <span className="heading-part-2">Many Times</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      {/* ✅ Modal render here */}
    </div>
  );
};

export default Profilesec1;
